
import { Check, Target, TrendingUp, Shield } from "lucide-react";

const DesiredOutcomes = () => {
  const outcomes = [
    {
      icon: Target,
      title: "Your tags fire exactly when they should",
      description: "No more guesswork, no more debugging sessions that go nowhere."
    },
    {
      icon: TrendingUp,
      title: "Events, conversions, and funnels appear cleanly",
      description: "See clear data in GA4 or Matomo that actually makes sense."
    },
    {
      icon: Shield,
      title: "Reliable insights you can use to grow",
      description: "Finally have dependable data you can trust for business decisions."
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center animate-on-scroll">
          <h2 className="mb-6">Imagine Analytics That <span className="text-primary">Just Works</span></h2>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {outcomes.map((outcome, index) => (
              <div 
                key={index}
                className="bg-accent border border-primary/20 rounded-xl p-8 text-center hover:shadow-lg transition-all duration-300 animate-on-scroll"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
                  <outcome.icon className="h-8 w-8 text-primary" />
                </div>
                <div className="flex items-center justify-center gap-2 mb-4">
                  <Check className="h-5 w-5 text-success flex-shrink-0" />
                  <h3 className="text-xl font-semibold text-text-primary">{outcome.title}</h3>
                </div>
                <p className="text-text-secondary leading-relaxed">{outcome.description}</p>
              </div>
            ))}
          </div>

          <div className="bg-white border border-border-color rounded-xl p-8 shadow-sm animate-on-scroll">
            <h3 className="text-2xl font-semibold text-text-primary mb-4">The New Paradigm:</h3>
            <p className="text-lg text-text-secondary leading-relaxed">
              This isn't another patchwork fix. With expert tracking setup tailored to your stack, 
              you'll have dependable data, simplified processes, and peace of mind. 
              Your analytics become a growth engine, not a source of frustration.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DesiredOutcomes;
